import React, { useEffect, useState, useRef } from 'react';
import Webcam from "react-webcam";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Stack from '@mui/material/Stack';
import StopwatchIcon from './timerStyle.svg';
import { parseNewDateToDDMMYYY } from '../../../Utils/dateHelper';
import { List, ListItem, Pagination, InputAdornment, Divider, Button, IconButton, Card, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography, Tooltip } from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";
import { LightenDarkenColor } from 'lighten-darken-color';
import { Key, TriangleAlert, Camera as CameraIcon, Send, Image, SwitchCamera, Circle, X } from 'lucide-react';
import { toast } from 'react-toastify';

function Stopwatch(props) {

    const classes = useStyles();
    const mounted = useRef(true);
    const countRef = useRef(null);

    // Timer
    const [timerSting, setTimerString] = useState(null);
    const [started, setStarted] = useState(false);
    const [startTime, setStartTime] = useState(null);

    // Comment
    const [openComment, setOpenComment] = useState(false);
    const [comment, setComment] = useState("");
    const [listOfComments, setListOfComments] = useState([]);
    const [commentError, setCommentError] = useState(false); // Comment validation

    // Image
    const webcamRef = React.useRef(null);
    const [image, setImage] = useState("");
    const [openCamera, setOpenCamera] = useState(false);
    const [cameraSide, setCameraSide] = useState(true)
    const [openFullscreenImage, setOpenFullscreenImage] = useState(false);
    const [captured, setCaptured] = useState(false);

    // Extra content
    const [extraContent, setExtraContent] = useState(false)
    const [expanded, setExpanded] = useState(false);
    const [page, setPage] = useState(1);

    const titleRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            if (titleRef.current) {
                const element = titleRef.current;

                // Temporarily remove the clamp styles to measure natural height
                const originalStyle = element.style.webkitLineClamp;
                element.style.webkitLineClamp = "unset";
                element.style.display = "block";

                // Measure natural height
                const naturalHeight = element.getBoundingClientRect().height;

                // Restore original styles
                element.style.webkitLineClamp = originalStyle;
                element.style.display = "-webkit-box";

                // Get line height dynamically
                const lineHeight = parseFloat(window.getComputedStyle(element).lineHeight);
                const maxHeight = lineHeight * 2; // Two lines

                setIsOverflowing(naturalHeight > maxHeight);
            }
        };

        checkOverflow();
        window.addEventListener("resize", checkOverflow);
        return () => window.removeEventListener("resize", checkOverflow);
    }, [props.description]);

    const titleElement = (
        <h2 ref={titleRef} className={classes.h2style}>
            {props.description}
        </h2>
    );

    useEffect(() => {
        if (props.stopwatch !== null && props.stopwatch !== undefined) {
            var s = (props.stopwatch.value * 1000);

            function pad(number) {
                if (number < 10) {
                    return number = "0" + String(number);
                } else {
                    return number = String(number);
                }
            }

            var ms = s % 1000;
            s = (s - ms) / 1000;
            var secs = s % 60;
            s = (s - secs) / 60;
            var mins = s % 60;
            s = (s - mins) / 60
            var hrs = s % 24;
            s = (s - hrs) / 24;

            if (mounted.current) {
                setTimerString(pad(hrs) + ':' + pad(mins) + ':' + pad(secs));
            }
        }
    }, [props.refresh, props.stopwatch]);

    useEffect(() => {
        setListOfComments(props.comments)
        // eslint-disable-next-line no-undef
    }, [props.refresh, props.comments]);

    const cameraFace = {
        facingMode: "user"
    }

    const cameraBack = {
        facingMode: { exact: "environment" }
    }

    const handleDialogOpenComment = () => {
        setOpenComment(true);
    }

    const handleDialogCloseComment = () => {
        setOpenComment(false);
    }

    const handleDialogOpenCamera = () => {
        setOpenCamera(true);
        setOpenComment(false);
    }

    const handleDialogCloseCamera = () => {
        setOpenCamera(false);
        setOpenComment(true);
    }

    const handleDialogOpenFullscreenImage = () => {
        setOpenFullscreenImage(true);
    }

    const handleDialogCloseFullscreenImage = () => {
        setOpenFullscreenImage(false);
    }

    const Cameramode = () => {
        setCameraSide(!cameraSide)
    }

    const handleExtraContentClick = () => {
        setExtraContent(!extraContent);
    };

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const handlePage = (event, value) => {
        setPage(value);
    };

    const handleStart = () => {
        if (props.keyRequired && !props.keyFound) {
            toast.error('Required field must be filled in and submitted', { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
        } else {
            setStarted(true)
            setStartTime(new Date())

            if (props.comment) {
                setComment("");
                setImage("");
                handleDialogOpenComment();
            }

            if (!started) {
                let startTime = new Date()
                countRef.current = (setInterval(() => {

                    var s = (new Date() - startTime + parseInt(props.stopwatch.value) * 1000)

                    function pad(number) {
                        if (number < 10) {
                            return number = "0" + String(number)
                        }
                        else {
                            return number = String(number)
                        }
                    }

                    var ms = s % 1000;
                    s = (s - ms) / 1000;
                    var secs = s % 60;
                    s = (s - secs) / 60;
                    var mins = s % 60;
                    s = (s - mins) / 60
                    var hrs = s % 24;
                    s = (s - hrs) / 24

                    if (mounted.current) {
                        setTimerString(pad(hrs) + ':' + pad(mins) + ':' + pad(secs));
                    }

                }
                    , 1000
                ))
                if (!props.comment) {
                    props.startAction(props.stopwatch.value, props.id, new Date());
                } else {
                    props.startActionWithComment(props.stopwatch.value, props.id, new Date());
                }
            }
        }
    }

    // const handleStartWithComment = () => {
    //     setReadyToAddComment(true);
    //     props.startActionWithComment(props.stopwatch.value, props.id, startTime, image.slice(23), comment)
    // }

    const capture = () => {
        const imageSrc = webcamRef.current.getScreenshot();
        if (imageSrc !== null) {
            setCaptured(true);
            setImage(imageSrc);
        }
        else {
            alert("No Camera Found");
        }

    }

    const CameraStyle = {
        width: "100%",
        height: "100%",
        position: "absolute",
        objectFit: "cover",
        top: "0",
        left: "0",
    }

    useEffect(() => {
        if (props.resetAllExcept !== null && props.resetAllExcept !== props.id && started) {
            setStarted(false);
            clearInterval(countRef.current);
            // setTimerString("00:00:00");
            props.stopAction(Math.floor(parseInt(props.stopwatch.value) + (new Date() - startTime) / 1000), props.id, new Date(), false);
        }
    }, [props.resetAllExcept])

    const handlePause = () => {
        if (props.keyRequired && !props.keyFound) {
            toast.error('Required field must be filled in and submitted', { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
        } else {
            if (started) {
                setStarted(false)
                clearInterval(countRef.current)
                props.stopAction(Math.floor(parseInt(props.stopwatch.value) + (new Date() - startTime) / 1000), props.id, new Date(), false);
                // props.action(formatDateTime(), props.id);
            }
        }

    }

    const handleReset = () => {
        if (props.keyRequired && !props.keyFound) {
            toast.error('Required field must be filled in and submitted', { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
        } else {
            setStarted(false)
            clearInterval(countRef.current)
            setTimerString("00:00:00")
            props.stopAction(Math.floor(parseInt(props.stopwatch.value) + (new Date() - startTime) / 1000), props.id, new Date(), true);
        }

    }

    const addComment = () => {
        setCommentError(false);
        if (comment.trim().length > 0 || image.trim().length > 0) {
            props.addCommentAction(props.id, image.slice(23), comment);
            setComment("");
            setImage("");
            setOpenComment(false);
        } else {
            setCommentError(true);
        }
    }

    return (
        <div>
            <Card>
                <div className={classes.StyleStopwatch} style={{
                    color: props.textColor,
                    backgroundColor: `${props.color}`
                }}>
                    <div className={classes.headerDiv} >
                        {props.isKey && <Key className={classes.keyStyle}></Key>}
                        {props.comment && (listOfComments.length > 0 || listOfComments !== "") ?
                            <Button style={{ zIndex: "4", position: "absolute", left: "3%" }} size={'large'} onClick={handleExtraContentClick}>
                                <TriangleAlert style={{ color: props.textColor }} />
                            </Button>
                            :
                            <React.Fragment></React.Fragment>
                        }
                        {isOverflowing ? (
                            <Tooltip title={props.description} placement="top" arrow>
                                {titleElement}
                            </Tooltip>
                        ) : (
                            titleElement
                        )}
                        <img className={classes.imageStyle} src={StopwatchIcon} style={{ filter: props.darkness ? 'invert(1)' : 'contrast(80%)' }} alt="" />
                    </div>
                    <Divider></Divider>
                    <div className={classes.stopwatchDev} style={{ backgroundColor: LightenDarkenColor(props.color, 20) }}>
                        <p className={classes.Style}>{timerSting}</p>
                    </div>
                    <Divider></Divider>
                    <Stack direction="row" className={classes.buttonDiv}
                        justifyContent="center"
                        alignItems="center"
                        spacing={1}>
                        <IconButton size={'large'} className={classes.ResetStyle} onClick={handleReset} style={{ color: props.textColor }} >
                            <RestartAltIcon fontSize="inherit" />
                        </IconButton>
                        <IconButton size={'large'} className={classes.PauseStyle} onClick={handlePause} style={{ color: props.textColor }}>
                            <PauseIcon fontSize="inherit" />
                        </IconButton>
                        <IconButton size={'large'} className={classes.StartStyle} onClick={handleStart} style={{ color: props.textColor }}>
                            <PlayArrowIcon fontSize="inherit" />
                        </IconButton>
                    </Stack>
                </div>

                <Dialog
                    fullScreen
                    open={openCamera}
                    onClose={handleDialogCloseCamera}
                    maxWidth={"lg"}
                >
                    <DialogTitle style={{ background: "rgba(0, 0, 0, .25)", zIndex: "1", color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h3>{"Camera"}</h3>
                        <IconButton onClick={handleDialogCloseCamera} size="large">
                            <X style={{ color: "white", width: '40px', height: '40px' }} />
                        </IconButton>
                    </DialogTitle>
                    <Divider></Divider>
                    <DialogContent>
                        {
                            cameraSide === true ?
                                <Webcam
                                    style={CameraStyle}
                                    audio={false}
                                    ref={webcamRef}
                                    screenshotFormat="image/jpeg"
                                    videoConstraints={cameraBack}
                                ></Webcam> :
                                <Webcam
                                    style={CameraStyle}
                                    audio={false}
                                    ref={webcamRef}
                                    screenshotFormat="image/jpeg"
                                    videoConstraints={cameraFace}
                                ></Webcam>
                        }
                    </DialogContent>
                    <Divider></Divider>
                    <DialogActions style={{ justifyContent: "center", background: "rgba(0, 0, 0, .25)", zIndex: "1" }}>
                        <IconButton onClick={handleExpandClick} size="large">
                            {(captured && image !== "") ?
                                <img alt="afbeelding" style={{ margin: "0px", width: "2rem", height: "2rem", borderRadius: "50%" }} src={image}></img>
                                :
                                <Image fontSize="inherit" style={{ color: "white", width: '40px', height: '40px' }} />
                            }
                        </IconButton>
                        <IconButton onClick={capture} size="large">
                            <Circle fontSize="inherit" style={{ color: "white", width: '40px', height: '40px' }} />
                        </IconButton>
                        <IconButton onClick={Cameramode} size="large">
                            <SwitchCamera fontSize="inherit" style={{ color: "white", width: '40px', height: '40px' }} />
                        </IconButton>
                    </DialogActions>
                    <Divider style={{ background: "rgb(0, 0, 0)", zIndex: "2" }}></Divider>
                    <Collapse style={{ background: "rgb(255, 255, 255)", zIndex: "2" }} in={expanded} timeout="auto" unmountOnExit>
                        <DialogContent style={{ background: "rgb(255, 255, 255)", zIndex: "2" }}>
                            <img alt="afbeelding"
                                style={{ background: "rgb(255, 255, 255)", zIndex: "2", maxWidth: "100%", maxHeight: "calc(100vh - 64px)" }}
                                src={image}></img>
                        </DialogContent>
                    </Collapse>
                </Dialog>

                <Dialog
                    fullWidth
                    open={openComment && props.openCommentDialog}>
                    <DialogTitle>
                        {"Comment"}
                    </DialogTitle>
                    <Divider ></Divider>
                    <div className={classes.StyleDivComment}>
                        {commentError &&
                            <label className={classes.label}>Please add a comment before submitting</label>
                        }
                        <TextField multiline
                            rows={8}
                            style={{ marginTop: "0px", margin: "10px", marginBottom: "10px", width: "87%" }}
                            label={comment ? " " : "Make a comment."}
                            InputLabelProps={{ shrink: false }} variant="outlined"
                            onChange={(event) => setComment(event.target.value)}
                            value={comment}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment style={{ marginTop: "160px" }}>
                                        {image !== "" ?
                                            <div>
                                                <IconButton onClick={handleDialogOpenFullscreenImage}>
                                                    <img alt="afbeelding" style={{ margin: "0px", width: "2rem", height: "2rem", borderRadius: "50%" }} src={image}></img>
                                                </IconButton>
                                                <IconButton onClick={handleDialogOpenCamera} >
                                                    <CameraIcon />
                                                </IconButton>
                                            </div>
                                            :
                                            <div>
                                                <IconButton onClick={handleDialogOpenCamera} >
                                                    <CameraIcon />
                                                </IconButton>
                                            </div>
                                        }
                                    </InputAdornment>)
                            }} />
                        <IconButton style={{ marginBottom: "12px" }} onClick={addComment} size="large">
                            <Send fontSize="inherit" color='blue' />
                        </IconButton>
                    </div>
                </Dialog>


                <Dialog
                    fullScreen
                    open={openFullscreenImage}
                    onClose={handleDialogCloseFullscreenImage}>
                    <DialogTitle style={{ background: "rgba(0, 0, 0, .25)", zIndex: "1", display: 'flex', justifyContent: 'end' }}>
                        <IconButton style={{}} onClick={handleDialogCloseFullscreenImage} size="large">
                            <X fontSize="inherit" color='white' style={{ width: '40px', height: '40px' }} />
                        </IconButton>
                    </DialogTitle>
                    <Divider ></Divider>
                    <DialogContent>
                        <img alt="afbeelding" style={CameraStyle} src={image}></img>
                    </DialogContent>
                </Dialog>
            </Card>
            {
                extraContent ? <div style={{ position: "relative" }}>
                    <div style={{ position: "absolute", top: "1", width: "100%", zIndex: "10" }}>
                        <Collapse in={extraContent} timeout="auto" unmountOnExit >
                            <Card >
                                {listOfComments.filter(list => list.index === page).map(x =>
                                    <List sx={{ width: '100%', overflow: "hidden" }}>
                                        <ListItem>
                                            <Typography style={{ width: "70%" }} >{props.description + " Comment: " + x.index}</Typography>
                                            <Typography style={{ width: "30%", fontWeight: "bold" }}>{parseNewDateToDDMMYYY(new Date(x.insertedOn))}</Typography>
                                        </ListItem>
                                        <Divider></Divider>
                                        {x.image !== "" && x.image !== null ?
                                            <ListItem style={{ marginBottom: "10px", display: "flex", justifyContent: "center" }}>
                                                <img alt="afbeelding" src={x.image} style={{ maxWidth: "100%", maxHeight: "calc(40vh - 16px)", borderRadius: "15px" }} />
                                            </ListItem>
                                            :
                                            <React.Fragment></React.Fragment>}
                                        {x.comment !== "" ?
                                            <ListItem>
                                                <Typography style={{ hyphens: "auto", wordWrap: "break-word", overflowWrap: "anywhere" }}>{x.comment}</Typography>
                                            </ListItem>
                                            :
                                            <React.Fragment></React.Fragment>}
                                        {x.comment === "" && (x.image === "" || x.image === null) ?
                                            <ListItem>
                                                <Typography style={{ color: "red" }} >No recorded comment.</Typography>
                                            </ListItem>
                                            :
                                            <React.Fragment></React.Fragment>}
                                        <Divider></Divider>
                                        <ListItem style={{ justifyContent: 'center' }}>
                                            <Pagination page={page} variant="outlined" size="small" siblingCount={0} count={listOfComments.length} onChange={handlePage} />
                                        </ListItem>
                                    </List>
                                )
                                }
                            </Card>
                        </Collapse>
                    </div>
                </div> :
                    <React.Fragment></React.Fragment>
            }
        </div>
    );
}
export default Stopwatch;

const useStyles = makeStyles({

    headerDiv: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '33%',
    },
    h2style: {
        margin: '0',
        zIndex: '2',
        maxWidth: 'calc(100% - 150px)',

        // break words if they are too long
        whiteSpace: 'normal',
        textOverflow: 'ellipsis',
        wordWrap: 'break-word',

        // max two lines
        display: '-webkit-box',
        WebkitLineClamp: '2',
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
    },
    Style: {
        borderRadius: "50px",
        textAlign: "center",
        fontSize: "2.5rem",
        margin: "0",
    },
    imageStyle: {
        position: 'absolute',
        right: '3%',
        opacity: '50%',
        width: '50px'
    },
    keyStyle: {
        position: 'absolute',
        left: '3%',
        opacity: '50%',
        width: '50px'
    },
    buttonDiv: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '33%',
    },
    StartStyle: {
        background: "#4CAF50",
        color: "white",
        textAlign: "center",
        marginLeft: "1rem",
        marginRight: "1rem",
    },
    PauseStyle: {
        backgroundColor: "#C3996B",
        color: "white",
        textAlign: "center",
        marginLeft: "1rem",
        marginRight: "1rem",
    },
    stopwatchDev: {
        display: "flex",
        justifyContent: "center",
        height: '34%',
        alignItems: 'center',
    },
    ResetStyle: {
        background: "#ff4c54",
        color: "white",
        textAlign: "center",
        marginLeft: "1rem",
        marginRight: "1rem",
    },
    StyleStopwatch: {
        overflow: 'hidden',
        backgroundRepeat: "no-repeat",
        backgroundSize: "10rem 10rem",
        backgroundPosition: "center",
        height: "12rem"
    },

    label: {
        height: "18px",

        color: "red",
        fontSize: "16px",

        marginTop: "16px",
        marginBottom: "4px",
        marginLeft: "10px",
    },
});